// import potentialsOrigin from "../data/potentials.json";
// import equipsOrigin from "../data/equipments.json";

import { loadData } from "./dataLoader";

let potentialsOrigin;
let equipsOrigin;

const load = () => {
    loadData("potentials.json").then((data) => (potentialsOrigin = data));
    loadData("equipments.json").then((data) => (equipsOrigin = data));
};

load();

const CHARS = "0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz";

const STAT_TYPE = {
    atk: 0,
    hp: 1,
    def: 3,
    spd: 4,
    crit_rate: 5,
    crit_dmg: 6,
    eff_rate: 7,
    eff_resist: 8,
};
const STAT_TYPE_INV = Object.fromEntries(Object.entries(STAT_TYPE).map(([k, v]) => [v, k]));

function base62Encode(buf) {
    let num = 0n;
    for (const byte of buf) num = (num << 8n) | BigInt(byte);

    let result = "";
    while (num > 0n) {
        result = CHARS[Number(num % 62n)] + result;
        num /= 62n;
    }
    // 8바이트 고정이므로 최소 길이 패딩
    while (result.length < 11) result = "0" + result;
    return result;
}

function base62EncodeVar(buf) {
    let num = 0n;
    for (const byte of buf) num = (num << 8n) | BigInt(byte);
    if (num === 0n) return "0";
    let result = "";
    while (num > 0n) {
        result = CHARS[Number(num % 62n)] + result;
        num /= 62n;
    }
    return result;
}

function base62Decode(str) {
    let num = 0n;
    for (const ch of str) num = num * 62n + BigInt(CHARS.indexOf(ch));

    const buf = new Uint8Array(8);
    for (let i = 7; i >= 0; i--) {
        buf[i] = Number(num & 0xffn);
        num >>= 8n;
    }
    return buf;
}

function base62DecodeVar(str) {
    let num = 0n;
    for (const ch of str) num = num * 62n + BigInt(CHARS.indexOf(ch));
    const bytes = [];
    while (num > 0n) {
        bytes.unshift(Number(num & 0xffn));
        num >>= 8n;
    }
    return new Uint8Array(bytes);
}

function readBigUInt64BE(buf) {
    let val = 0n;
    for (let i = 0; i < 8; i++) val = (val << 8n) | BigInt(buf[i]);
    return val;
}

function encodeCharPreset(preset) {
    // BigInt로 처리 (60bit이라 Number 안전범위 초과)
    let bits = 0n;
    bits = (bits << 16n) | BigInt(preset.charId);
    bits = (bits << 4n) | BigInt(preset.slot);
    bits = (bits << 9n) | BigInt(preset.level);
    bits = (bits << 4n) | BigInt(preset.resonance);
    bits = (bits << 6n) | BigInt(preset.favor);
    bits = (bits << 2n) | BigInt(preset.limitBreak);
    bits = (bits << 4n) | BigInt(preset.skillLevels[0]);
    bits = (bits << 4n) | BigInt(preset.skillLevels[1]);
    bits = (bits << 4n) | BigInt(preset.skillLevels[2]);
    bits = (bits << 4n) | BigInt(preset.skillLevels[3]);
    bits = (bits << 3n) | BigInt(preset.starGrade);
    // 60bit → 8바이트 (상위 4bit 패딩)

    const buf = new Uint8Array(8);
    for (let i = 7; i >= 0; i--) {
        buf[i] = Number(bits & 0xffn);
        bits >>= 8n;
    }
    return base62Encode(buf);
}

function decodeCharPreset(code, name) {
    const buf = base62Decode(code);
    let bits = readBigUInt64BE(buf);

    const starGrade = Number(bits & 0x7n);
    bits >>= 3n;
    const skillLevel3 = Number(bits & 0xfn);
    bits >>= 4n;
    const skillLevel2 = Number(bits & 0xfn);
    bits >>= 4n;
    const skillLevel1 = Number(bits & 0xfn);
    bits >>= 4n;
    const skillLevel0 = Number(bits & 0xfn);
    bits >>= 4n;
    const limitBreak = Number(bits & 0x3n);
    bits >>= 2n;
    const favor = Number(bits & 0x3fn);
    bits >>= 6n;
    const resonance = Number(bits & 0xfn);
    bits >>= 4n;
    const level = Number(bits & 0x1ffn);
    bits >>= 9n;
    const slot = Number(bits & 0xfn);
    bits >>= 4n;
    const charId = Number(bits & 0xffffn);

    return {
        charId,
        slot,
        name,
        level,
        resonance,
        favor,
        limitBreak,
        skillLevels: [skillLevel0, skillLevel1, skillLevel2, skillLevel3],
        starGrade,
    };
}

function encodeArchivePreset(preset) {
    let bits = 0n;

    bits = (bits << 16n) | BigInt(preset.charId);
    bits = (bits << 4n) | BigInt(preset.slot);
    bits = (bits << 12n) | BigInt(preset.stat.str);
    bits = (bits << 12n) | BigInt(preset.stat.hp);
    bits = (bits << 12n) | BigInt(preset.stat.end);
    bits = (bits << 12n) | BigInt(preset.stat.focus);
    bits = (bits << 12n) | BigInt(preset.stat.prot);

    const count = preset.potentials.length;
    bits = (bits << 4n) | BigInt(count);

    for (const pot of preset.potentials) {
        bits = (bits << 17n) | BigInt(pot.id);
        bits = (bits << 3n) | BigInt(pot.level);
    }

    const totalBits = 84 + count * 20;
    const byteLen = Math.ceil(totalBits / 8);

    const buf = new Uint8Array(byteLen + 1);
    buf[0] = byteLen;
    let tmp = bits;
    for (let i = byteLen; i >= 1; i--) {
        buf[i] = Number(tmp & 0xffn);
        tmp >>= 8n;
    }
    return base62EncodeVar(buf);
}

function decodeArchivePreset(code, name) {
    const raw = base62DecodeVar(code);
    const byteLen = raw[0];
    const buf = raw.slice(1, 1 + byteLen);

    // 바이트 배열을 하나의 BigInt로
    let bits = 0n;
    for (const byte of buf) bits = (bits << 8n) | BigInt(byte);

    let remaining = buf.length * 8;

    function take(n) {
        remaining -= n;
        return Number((bits >> BigInt(remaining)) & ((1n << BigInt(n)) - 1n));
    }

    const charId = take(16);
    const slot = take(4);
    const str = take(12);
    const hp = take(12);
    const end = take(12);
    const focus = take(12);
    const prot = take(12);
    const count = take(4);

    const potentials = [];
    for (let k = 0; k < count; k++) {
        const id = take(17);
        const level = take(3);

        const origin = potentialsOrigin.find((e) => e.id === id);

        if (origin) {
            potentials.push({ id, name: origin.name, level, maxLevel: origin.levels.length });
        }
    }

    return {
        charId,
        slot,
        name,
        stat: { str, hp, end, focus, prot },
        potentials,
    };
}

function encodeEquipPreset(preset) {
    let bits = 0n;

    bits = (bits << 16n) | BigInt(preset.charId);
    bits = (bits << 4n) | BigInt(preset.slot);

    for (const eq of preset.equips) {
        bits = (bits << 3n) | BigInt(eq.part);
        bits = (bits << 3n) | BigInt(eq.tier);
        bits = (bits << 3n) | BigInt(eq.grade);
        bits = (bits << 5n) | BigInt(eq.setId);
        bits = (bits << 1n) | BigInt(eq.isEngraved ? 1 : 0);
        bits = (bits << 4n) | BigInt(eq.enhanced);

        // mainOption
        bits = (bits << 4n) | BigInt(STAT_TYPE[eq.mainOption.statType]);
        bits = (bits << 1n) | BigInt(eq.mainOption.isPercent ? 1 : 0);
        bits = (bits << 16n) | BigInt(eq.mainOption.value ?? eq.mainOption.baseValue);

        // subOptions 4개 고정 (부족하면 0 패딩)
        for (let k = 0; k < 4; k++) {
            const sub = eq.subOptions[k];
            if (sub) {
                bits = (bits << 4n) | BigInt(STAT_TYPE[sub.statType]);
                bits = (bits << 1n) | BigInt(sub.isPercent ? 1 : 0);
                bits = (bits << 16n) | BigInt(sub.value);
            } else {
                bits = (bits << 21n) | 0n; // 패딩
            }
        }
    }

    const byteLen = Math.ceil(764 / 8); // 96바이트
    const buf = new Uint8Array(byteLen);
    let tmp = bits;
    for (let i = byteLen - 1; i >= 0; i--) {
        buf[i] = Number(tmp & 0xffn);
        tmp >>= 8n;
    }
    return base62EncodeVar(buf);
}

function decodeEquipPreset(code, name) {
    const buf = base62DecodeVar(code);
    let bits = 0n;
    for (const byte of buf) bits = (bits << 8n) | BigInt(byte);

    let remaining = 764;
    function take(n) {
        remaining -= n;
        return Number((bits >> BigInt(remaining)) & ((1n << BigInt(n)) - 1n));
    }

    const charId = take(16);
    const slot = take(4);

    const equips = [];
    for (let e = 0; e < 6; e++) {
        const part = take(3);
        const tier = take(3);
        const grade = take(3);
        const setId = take(5);
        const isEngraved = take(1) === 1;
        const enhanced = take(4);

        const origin = equipsOrigin.find((e) => e.part === part && e.tier === tier && e.grade === grade && e.set_id === setId);
        let name = "";
        let img = "";

        let mainOption = {
            statType: STAT_TYPE_INV[take(4)],
            isPercent: take(1) === 1,
            baseValue: take(16),
        };

        if (origin) {
            name = origin.name;
            img = origin.img;

            const stat = origin.main_stats.find((e) => e.type === mainOption.statType && e.is_percent === mainOption.isPercent);
            if (stat) {
                mainOption.baseValue = stat.init_value;
                mainOption.gap = stat.gap;
            }
        }

        const subOptions = [];
        for (let k = 0; k < 4; k++) {
            const statType = take(4);
            const isPercent = take(1) === 1;
            const value = take(16);
            // 패딩 슬롯은 제외
            if (statType !== 0 || value !== 0) {
                subOptions.push({ statType: STAT_TYPE_INV[statType], isPercent, value });
            }
        }

        if (name !== "" && img !== "") {
            equips.push({ part, tier, grade, setId, name, img, isEngraved, enhanced, mainOption, subOptions });
        }
    }

    return { charId, slot, name, equips };
}

export { encodeCharPreset, decodeCharPreset, encodeArchivePreset, decodeArchivePreset, encodeEquipPreset, decodeEquipPreset };
